export const STATEMENTS_TABLE = {
  content: [
    'I DON’T WANT TO GET PREGNANT WITHIN THE NEXT YEAR.',
    'I’M LOOKING FOR AN OPTION THAT DOES NOT DEPEND ON DAILY, WEEKLY, OR MONTHLY DOSING.',
    'I’M LOOKING FOR SOMETHING THAT DOESN’T GO IN MY UTERUS.',
    'I’M OPEN TO HAVING A BIRTH CONTROL IMPLANT IN MY ARM.',
    'I WANT A BIRTH CONTROL THAT’S REVERSIBLE.',
    'I’M A NEW MOM AND AM LOOKING FOR BIRTH CONTROL.',
  ],
};
